import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router, NavigationExtras} from '@angular/router';
import {Card} from '../../../card-container/card/card';
import {LoginService} from '../../../../../shared-modules/login/login.service';
import { MatDialog } from '@angular/material/dialog';
import {YearService} from '../../../../../shared-components/year/year.service';
import {StudentService} from '../../../../../shared-components/student/student.service';
import {StudentSummaryService} from '../../../student-summary.service';
import * as _ from 'lodash';
import {CardFeesAndBilling} from './card-fees-and-billing';
import {FeesAndBillingCardModalComponent} from './fees-and-billing-card-modal/fees-and-billing-card-modal.component';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {interval, Subscription} from 'rxjs';
import {UserService} from '../../../../../shared-components/user/user.service';
import {OnlinePaymentConfiguration} from '../../../../online-payment/models/online-payment-config.model';
import {Year} from '../../../../../shared-components/year/year.model';
import { Student360Service } from '../../../../student360.service';
import { Portal } from '../../../../../shared-components/portal.model';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-fees-billing-card',
    templateUrl: './fees-billing-card.component.html',
    styleUrls: ['./fees-billing-card.component.css']
})

export class FeesBillingCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    card: Card;
    totalString = '';
    creditOrDue = '';
    feesLedger: CardFeesAndBilling[] = [];
    displayedColumns: string[] = ['Code', 'Description', 'Balance', 'CreditOrDue'];
    onlinePaymentConfiguration: OnlinePaymentConfiguration = new OnlinePaymentConfiguration();
    userType: number;
    parentPortalShowOnlinePayment: boolean;
    student360Year: Year;
    StudentFinesAndFeesOnlinePayment: boolean;
    onlinePaymentConfigurationSubscription: Subscription;
    showPay = false;
    parentAssignedPortalsSubscription: Subscription;
    portals: Portal[] = [];

    constructor(private loginService: LoginService,
        private dialog: MatDialog,
        private yearService: YearService,
        private userService: UserService,
        private studentService: StudentService,
        private studentSummaryService: StudentSummaryService,
        private parentPortalService: Student360Service,
        private router: Router) {
        this.studentService.observableOnlinePaymentConfigurationStream$.subscribe(onlinePaymentConfiguration => {
            if (onlinePaymentConfiguration) {
                this.onlinePaymentConfiguration = onlinePaymentConfiguration;
            }
        });

        this.parentAssignedPortalsSubscription = this.parentPortalService.observableParentAssignedPortalsStream$
            .subscribe(portals => {
                if (portals.length > 0) {
                    this.portals = portals.filter(portal => !portal.Deleted);
                }
            });
    }

    ngOnInit() {
        this.card = this.data;
        this.onlinePaymentConfiguration = this.studentService.onlinePaymentConfiguration;
        this.parentPortalShowOnlinePayment = this.loginService.LoginSettings.ParentPortalShowOnlinePayment;
        this.userType = this.userService.userType;
        this.student360Year = this.yearService.student360Year;
        if (this.userType == 2 && this.portals.filter(o => o.PortalName == 'Online Payment' && o.Disabled == false && o.ShowAsMenu == true && o.Deleted == false).length > 0) {
            this.showPay = true;
        }
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.gettFeesBalance();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    gettFeesBalance() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardFeesAndBilling(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.yearService.student360Year.Id).subscribe(response => {
            if (response.ok) {
                this.feesLedger = _.cloneDeep(response.body);
                // this.mockData();
                // Get the total string
                if (this.feesLedger.length > 0) {
                    if (this.feesLedger[0].Code == 'No Balance') {
                        this.totalString = marker('No fees owed for this student.').toString();
                    } else {
                        this.creditOrDue = this.feesLedger[0].TotalBalanceCreditOrDue;
                        this.totalString = '$' + this.numberWithCommas(this.feesLedger[0].TotalBalance.toFixed(2));
                    }
                }
            }
        });
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    checkTotalString(totalString: string) {
        if (this.creditOrDue.includes('Due')) {
            return 'redText';
        }
        if (totalString == 'No fees owed for this student.') {
            return 'smallSummaryText';
        }
        if (this.creditOrDue.includes('Credit')) {
            return 'blackText';
        }
    }

    checkIfBalance() {
        if (this.totalString == 'No fees owed for this student.') {
            return false;
        } else {
            return true;
        }
    }

    mockData() {
        // Clear the array to make room for some awesome mock data!
        this.feesLedger.length = 0;
        const fb1 = {} as CardFeesAndBilling;
        fb1.Code = 'ARTS';
        fb1.Description = 'Art Supplies';
        fb1.Balance = 3000;
        // DueorCredit can be Due, Credit or NB (no balance)
        fb1.DueorCredit = 'Due';
        fb1.TotalBalance = 70.70;
        fb1.TotalBalanceCreditOrDue = 'Due';
        this.feesLedger.push(fb1);
        const fb2 = {} as CardFeesAndBilling;
        fb2.Code = 'LIBR';
        fb2.Description = 'Library';
        fb2.Balance = 4.30;
        // DueorCredit can be Due, Credit or NB (no balance)
        fb2.DueorCredit = 'Credit';
        fb2.TotalBalance = 70.70;
        fb2.TotalBalanceCreditOrDue = 'Due';
        this.feesLedger.push(fb2);
        const fb3 = {} as CardFeesAndBilling;
        fb3.Code = 'TEXT';
        fb3.Description = 'Textbook';
        fb3.Balance = 50.00;
        // DueorCredit can be Due, Credit or NB (no balance)
        fb3.DueorCredit = 'Due';
        fb3.TotalBalance = 70.70;
        fb3.TotalBalanceCreditOrDue = 'Due';
        this.feesLedger.push(fb3);
    }

    viewDetailsClick() {
        if (!this.card.disabled) {
            this.router.navigateByUrl('/student360/feesAndBilling');
        }
    }

    isDisabled() {
        if (this.card.disabled) {
            return 'disabledColor';
        } else {
            return 'enabledColor';
        }
    }

    cardClick() {
        if (!this.card.disabled) {
            this.dialog.open(FeesAndBillingCardModalComponent, {
                minWidth: '40vw',
                maxHeight: '80vh',
                data: {
                    feesLedger: this.feesLedger, totalString: this.totalString,
                    showPay: this.showPay,
                },
                disableClose: true,
                autoFocus: false
            });
        }
    }

    payClick() {
        const navigationExtras: NavigationExtras = {
            // The view to Fee & Billing Accounts
            queryParams: {
                'selectedView': 1
            }
        };
        this.router.navigate(['/student360/onlinePayment'], navigationExtras);
    }

}
